import {
  KNOWN_STATUS_LABELS,
  ORDER_STATUS_TEXT_COLOR,
  ORDER_STATUS_TEXT_COLOR_FALLBACK,
  PROGRESOL_SCOPED_STATUS_LABELS,
  UNMAPPED_STATUS_PLACEHOLDER,
} from '@constants';
import { PalleteColor } from 'nanaykuna-ui-kit/loader';

export function equalsIgnoreCase(
  a?: string | null,
  b?: string | null,
): boolean {
  return (a ?? '').trim().toLowerCase() === (b ?? '').trim().toLowerCase();
}

export function getKnownStatusLabel(
  statusName: string | null | undefined,
  knownLabels: readonly string[],
  placeholder: string,
): string {
  if (
    !statusName ||
    !knownLabels.some(known => equalsIgnoreCase(known, statusName))
  ) {
    return placeholder;
  }
  return statusName;
}

export function getDisplayStatusLabel(
  statusName: string | null | undefined,
): string {
  return getKnownStatusLabel(
    statusName,
    KNOWN_STATUS_LABELS,
    UNMAPPED_STATUS_PLACEHOLDER,
  );
}

// Same tolerance as getDisplayStatusLabel: the API's status casing and
// whitespace drift, so the lookup compares case-insensitively.
export function getStatusTextColor(
  statusName: string | null | undefined,
): PalleteColor {
  const known = Object.keys(ORDER_STATUS_TEXT_COLOR).find(label =>
    equalsIgnoreCase(label, statusName),
  );
  return known
    ? ORDER_STATUS_TEXT_COLOR[known]
    : ORDER_STATUS_TEXT_COLOR_FALLBACK;
}

export function isProgresolScopedStatus(
  statusName: string | null | undefined,
): boolean {
  return PROGRESOL_SCOPED_STATUS_LABELS.some(label =>
    equalsIgnoreCase(label, statusName),
  );
}
